export default [{ //DC主数据维护
    path: '/DCList',
    component: () =>
        import('@/components/page/DC/DCList'),
    meta: { title: 'DC.DCMaintain' },
},
{ //DC主数据维护
    path: '/DCDetail',
    component: () =>
        import('@/components/page/DC/DCDetail'),
    meta: { title: 'DC.DCDetail' },
},
{ //DC主数据维护
    path: '/DCDetail/view',
    component: () =>
        import('@/components/page/DC/DCView'),
    meta: { title: 'DC.DCDetail' },
},
]